import { useMemo, useState } from "react";

export const useBuildingSlice = () => {
  const [selectedBuildings, setSelectedBuildings] = useState([]);
  const [selectedBuildingIds, setSelectedBuildingIds] = useState([]);

  return useMemo(() => ({ selectedBuildings, setSelectedBuildings, selectedBuildingIds, setSelectedBuildingIds }), [selectedBuildings, selectedBuildingIds]);
};
